import Error from '../shared/error';
import { APIErrorType } from '../../api';
import Loader from '../shared/loader';
import { useParams } from 'react-router-dom';
import { useStudentExam } from '../../hooks/react-query/use-student-exam';
import ExamReport from './exam-report';

function ExamReportContainer() {
  const { examId } = useParams();
  const {
    isError: studentExamIsError,
    error: studentExamError,
    isLoading: studentExamIsLoading,
    data: studentExam
  } = useStudentExam(examId ? parseInt(examId) : undefined);

  if (!examId) return <Error />;
  if (studentExamIsError) {
    const error = studentExamError as APIErrorType;
    return <Error error={error} />;
  }
  if (studentExamIsLoading || !studentExam) return <Loader />;

  return <ExamReport studentExam={studentExam} />;
}

export default ExamReportContainer;
